<template>
  <div style="position: absolute; left: 0; right: 0; top: 0; bottom: 0">
    <div
      :class="!showManagement ? 'align-to-right' : ''"
      :style="{ background: $getScoreColorHex(personnelAvg, scale), height: `${personnelAvg}%` }"
      class="chart-bar personnel-bar rounded-t"
    >
      <template v-if="showPersonnel">
        <div class="mt-1">{{ personnelAvg }}%</div>
        <div class="chart-bar-label">
          <span>{{ $t('teams.types.PERSONNEL') }}</span>
        </div>
      </template>
    </div>

    <div
      :style="{ background: $getScoreColorHex(managementAvg, scale), height: `${managementAvg}%` }"
      class="chart-bar management-bar rounded-t"
    >
      <template v-if="showManagement">
        <div class="mt-1">{{ managementAvg }}%</div>
        <div class="chart-bar-label">
          <span>{{ $t('teams.types.MANAGEMENT') }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportOverallChart',
  props: ['surveys', 'category'],
  computed: {
    scale() {
      if (this.category === 'culture' || this.category === 'economy_customers') {
        return [22.5, 72.5];
      }
      return [40, 60];
    },
    showManagement() {
      return this.managementAvg > 0;
    },
    showPersonnel() {
      return this.personnelAvg > 0;
    },
    personnelSurvey() {
      return this.surveys?.find(s => s.type === 'PERSONNEL');
    },
    managementSurvey() {
      return this.surveys?.find(s => s.type === 'MANAGEMENT');
    },
    personnelAvg() {
      if (!this.personnelSurvey) return 0;
      const value =
        this.personnelSurvey?.calculation?.engineResponse?.lta?.[this.category]?.avg?.reduce((acc, curr) => acc + curr.value, 0) /
        this.personnelSurvey?.calculation?.engineResponse?.lta?.[this.category]?.avg?.length;
      if (isNaN(value)) return -1;
      return parseFloat(value).toFixed(0);
    },
    managementAvg() {
      if (!this.managementSurvey) return 0;
      const value =
        this.managementSurvey?.calculation?.engineResponse?.oja?.[this.category]?.avg?.reduce((acc, curr) => acc + curr.value, 0) /
        this.managementSurvey?.calculation?.engineResponse?.oja?.[this.category]?.avg?.length;
      if (isNaN(value)) return -1;
      return parseFloat(value).toFixed(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-bar {
  position: absolute;
  bottom: 0;
  text-align: center;
  font-weight: bold;
  color: #fff;
  font-size: 0.7rem;
  transition: all 0.3s ease-in-out;

  &.personnel-bar {
    left: 0;
    right: calc(50% + 1px);

    &.align-to-right {
      left: calc(50% + 1px);
      right: 0;
    }
  }

  &.management-bar {
    left: calc(50% + 1px);
    right: 0;
  }

  .chart-bar-label {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 10px;
    font-weight: 400;

    span {
      display: block;
      position: absolute;
      bottom: -13px;
      left: 2px;
      transform-origin: 0 0;
      transform: rotate(-90deg);
    }
  }
}

@media screen and (min-width: 600px) {
  .chart-bar {
    font-size: 1.1rem;

    .chart-bar-label {
      font-size: 12px;
    }
  }
}
</style>
